import { EMPTY_TARIFF_MAPPING_MODEL } from "presentation/model/TariffMapping/TariffMappingModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: TariffMappingProvider,
    useTracked: useTariffMappingTracked
} = createContainer(() => useState(EMPTY_TARIFF_MAPPING_MODEL), {concurrentMode: true});
export { TariffMappingProvider, useTariffMappingTracked };
